import { KText } from '../../text';

export const KTag = ({ value = 'All', isTable = false, ...props }: any) => {
  return (
    <KText
      as="span"
      display="inline-flex"
      alignItems="center"
      textAlign="start"
      border="1px solid"
      borderColor="transparent"
      bgColor="secondary-50"
      borderRadius="sm"
      p="0.125em 0.5em"
      fontWeight={550}
      _groupHover={
        isTable ? { bg: 'base-white', borderColor: 'border-color' } : {}
      }
      {...props}
    >
      {value}
    </KText>
  );
};
